'use client';

import classNames from 'classnames';
import { defineMessage, useIntl } from 'react-intl';
import Handle from '@alltrails/denali/icons/Handle';
import type { DragHandleProps } from '../../types';
import styles from './styles/styles.module.scss';

const moveMessage = defineMessage({
  defaultMessage: 'Move'
});

const DragHandle = (dragHandleProps: DragHandleProps) => {
  const intl = useIntl();
  return (
    <div {...dragHandleProps} title={intl.formatMessage(moveMessage)} className={classNames(styles.container, 'item-move', 'clickable')}>
      <Handle color="--color-neutral-white" />
    </div>
  );
};

export default DragHandle;
